import {
  UsageRo,
  useLimitAndUsageControllerGetMyUsageQuery,
  useLimitAndUsageControllerGetUsageQuery,
} from 'src/app/services/api.generated';
import { useIsDemoUser } from './useIsDemoUser';

type useGetUsageType = (isManager: boolean) => {
  data?: UsageRo | null;
  isLoading: boolean;
};

export const useGetUsage: useGetUsageType = (isManager) => {
  const isDemoUser = useIsDemoUser();

  // All authenticated users get company allowance (used/max) via /usage.
  const { data: userUsage, isLoading: userUsageLoading } =
    useLimitAndUsageControllerGetUsageQuery(undefined as void, {
      skip: isDemoUser,
    });

  // Managers also get history + the richer company payload.
  const { data: companyUsage, isLoading: companyUsageLoading } =
    useLimitAndUsageControllerGetMyUsageQuery(undefined as void, {
      skip: !isManager || isDemoUser,
    });

  const data = companyUsage
    ? {
        ...userUsage,
        ...companyUsage,
        // Prefer company totals when both are present.
        pageCount: companyUsage.pageCount ?? userUsage?.pageCount,
        taskCount: companyUsage.taskCount ?? userUsage?.taskCount,
        maxPages: companyUsage.maxPages ?? userUsage?.maxPages,
      }
    : userUsage || null;

  return {
    data,
    isLoading: userUsageLoading || companyUsageLoading || false,
  };
};
